module.exports = __webpack_public_path__ + "img/insta.5edab154.svg";